import { useEffect, useState } from "react";

const oldWay = [
  "WhatsApp leads with no tracking",
  "Unanswered follow-up calls",
  "KYC mismatches found late",
  "Delayed, undocumented commission",
];

const finverseWay = [
  "Logged and trackable end to end",
  "Routed to whoever is actually funding that paper",
  "Caught upfront during verification",
  "Tracked against the exact disbursal",
];

const stats = [
  {
    value: 1240,
    suffix: "+",
    label: "Loans funded directly",
  },
  {
    value: 36,
    suffix: "",
    label: "Lenders partnered",
  },
  {
    value: 2800,
    suffix: "+",
    label: "DSAs onboarded",
  },
  {
    value: 4.2,
    suffix: " min",
    label: "Avg. verification time",
    decimal: true,
  },
];

function AnimatedNumber({ value, suffix, decimal }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 1600;
    const startTime = performance.now();

    let animationFrame;

    const animate = (currentTime) => {
      const progress = Math.min(
        (currentTime - startTime) / duration,
        1
      );

      // Smooth ease-out
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = value * easedProgress;

      setCount(
        decimal
          ? Number(currentValue.toFixed(1))
          : Math.floor(currentValue)
      );

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [value, decimal]);

  return (
    <>
      {decimal ? count.toFixed(1) : count}
      {suffix}
    </>
  );
}

function ComparisonStats() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">

        {/* =====================================================
            OLD WAY VS FINVERSE
        ====================================================== */}
        <div>
          {/* Label */}
          <p className="font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] text-[var(--mint-green)] uppercase mb-2.5">
            OLD WAY VS FINVERSE
          </p>

          {/* Comparison */}
          <div className="mt-5 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-16 lg:gap-x-20">

            {/* ================= OLD WAY ================= */}
            <div>
              <ul className="space-y-5">
                {oldWay.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2.5 font-jakarta text-[14px] leading-[1.45] text-[#858b87] sm:text-[15px]"
                  >
                    <span className="mt-[7px] h-[5px] w-[5px] shrink-0 rounded-full bg-[#858b87]" />

                    <span className="line-through decoration-[#858b87]/70 decoration-[1px]">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* ================= FINVERSE ================= */}
            <div>
              <ul className="space-y-5">
                {finverseWay.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 font-jakarta text-[14px] leading-[1.45] text-[#d7ddd9] sm:text-[15px]"
                  >
                    <span className="shrink-0 font-jakarta text-[14px] leading-[1.45] text-[var(--mint-green)]">
                      →
                    </span>

                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* =====================================================
            STATS CARD
        ====================================================== */}
        <div className="relative mt-14 overflow-hidden rounded-[24px] border border-white/10 bg-[#20382f] sm:mt-16 sm:rounded-[26px] lg:mt-20">

          {/* Gradient */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#173b31] via-[#253a2d] to-[#38371f]" />

          {/* Content */}
          <div className="relative px-5 py-8 sm:px-8 sm:py-9 lg:px-10 lg:py-10">

            {/* Stats */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-9 md:grid-cols-4 md:gap-x-8 md:gap-y-0">

              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-bricolage text-[36px] font-semibold leading-none tracking-[-1.5px] text-[var(--mint-green)] sm:text-[40px] lg:text-[41px]">
                    <AnimatedNumber
                      value={stat.value}
                      suffix={stat.suffix}
                      decimal={stat.decimal}
                    />
                  </div>

                  <p className="mt-3 font-jakarta text-[12px] leading-[1.4] text-[#aeb8b3] sm:text-[13px]">
                    {stat.label}
                  </p>
                </div>
              ))}

            </div>

            {/* Live status */}
            <div className="mt-9 flex items-center gap-2">
              <span className="h-[6px] w-[6px] rounded-full bg-[#f0d53b]" />

              <span className="font-jakarta text-[10px] font-semibold tracking-[0.28em] text-[#e5d24c] sm:text-[11px]">
                COUNTING UP FROM ZERO · LIVE
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ComparisonStats;